export const trDefaultOgDescription = {
	DE: 'Stöbern Sie in der größten LEGO® Auswahl in Luxemburg.',
	EN: 'Browse the largest LEGO® selection in Luxembourg.',
	FR: 'Parcourez la plus grande sélection LEGO® au Luxembourg.',
};
